import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout/layout.vue'
import Login from '../views/Login/login.vue'
import Home from '../views/Home/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    component: Layout,
    meta: {
      title: '首页',
      isLogin: true
    },
    children: [
      {
        path: '/', //首页路由
        name: 'home',
        component: Home
      },
      {
        path: '/Product', //项目管理路由
        name: 'Product',
        component: () => import('@/views/Product/index'),
        children: [
          {
            path: 'contact',
            name: 'contact',
            component: () => import('@/views/Product/contact/index')
          },
          {
            path: 'machineManage',
            name: 'machineManage',
            component: () => import('@/views/Product/machineManage/index')
          },
          {
            path: 'productManage',
            name: 'productManage',
            component: () => import('@/views/Product/productManage/index')
          }
        ]
      },
      {
        path: '/System', //系统管理路由
        name: 'System',
        component: () => import('@/views/System/index.vue'),
        children: [
          {
            path: 'organizationManage',
            name: 'organizationMagage',
            component: () => import('@/views/System/organizationManage/index.vue')
          },
          {
            path: 'userManage',
            name: 'userManage',
            component: () => import('@/views/System/userManage/index.vue')
          },
          {
            path: 'vendorCodeManage',
            name: 'vendorCodeManage',
            component: () => import('@/views/System/vendorCodeManage/index.vue')
          }
        ]
      },
      {
        path: '/Log', //日志记录路由
        name: 'Log',
        component: () => import('@/views/Log/index.vue'),
        children: [
          {
            path: 'callLog',
            name: 'callLog',
            component: () => import('@/views/Log/callLog/index.vue')
          },
          {
            path: 'dangerLog',
            name: 'dangerLog',
            component: () => import('@/views/Log/dangerLog/index.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('@/views/Login/login.vue'),
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

//配置路由全局前置守卫导航
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.name !== 'Login' && !token) next({ name: 'Login' })
  else next()
})
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
